import "../chunk-XTU7I5IS.js";
import { createDevOrStagingUrlCache } from "@clerk/shared/keys";
const { isDevOrStagingUrl } = createDevOrStagingUrlCache();
export {
  isDevOrStagingUrl
};
//# sourceMappingURL=isDevOrStageUrl.js.map